@use '@/styles/tokens' as *;

.content {
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
  background: var(--surface-card);
}

.header {
  position: relative;
  display: flex;
  // `flex-shrink: 0` is load-bearing, not tidiness. `.content` is a flex column and `.body` sizes
  // from its content, so a long body (the account-wide claims list seeds 25 rows) makes the column
  // overflow and flexbox shrinks EVERY shrinkable child proportionally — including this one. With
  // `overflow: hidden` below, the header shrinking below its content height slices the top off the
  // title. It reproduced as a clipped "Warranty Claims"; a short list never triggered it.
  flex-shrink: 0;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 24px 24px 16px;
  background: var(--surface-page);
  // Clips `.pattern`, which is absolutely positioned at 100% height with `object-fit: cover`.
  overflow: hidden;
}

.headings {
  z-index: 1;
}

.title {
  margin: 0;
  font-family: $font-family-heading;
  font-size: $font-size-2xl;
  font-weight: $font-weight-regular;
  letter-spacing: -0.02em;
  color: var(--text-primary);
}

.subtitle {
  margin: var(--space-1) 0 0;
  font-family: $font-family-base;
  font-size: $font-size-sm;
  font-weight: $font-weight-regular;
  color: var(--text-muted);
}

.pattern {
  pointer-events: none;
  user-select: none;
  position: absolute;
  inset-inline: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.9;
  z-index: 0;
}

.close {
  position: absolute;
  top: 16px;
  inset-inline-end: 16px;
  z-index: 1;
}

.body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 24px;
}

.footer {
  display: flex;
  // Same reason as `.header` above: a long body must not squash the footer, which carries the
  // pinned "Raise Warranty Claim" CTA at a fixed height.
  flex-shrink: 0;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px 24px;
}

.footerStart {
  margin-inline-end: auto;
}

.footerCenter {
  justify-content: center;
  background: var(--surface-page);
}

.footerFill {
  gap: var(--space-4);

  > * {
    flex: 1 1 0;
    font-size: $font-size-15;
  }
}

.danger {
  --ant-color-primary: var(--status-danger-strong);
  background: var(--status-danger-strong) !important;
  border-color: var(--status-danger-strong) !important;
  color: var(--text-inverse) !important;
}

.form {
  display: contents;
}

.footerRegion {
  flex: 0 0 auto;
}
